<div class="not-found-main-container">

  <div class="card-container">

    <img src="./assets/img/logo/openpay.webp"
         srcset="./assets/img/logo/openpay@2x.webp 2x,
             ./assets/img/logo/openpay@3x.webp 3x"
         class="openpay-logo"
         alt="openpay logo"
    >

    <div class="not-found-container">
      <img src="./assets/img/failure/failure.png"
           srcset="./assets/img/failure/failure@2x.png 2x,
             ./assets/img/failure/failure@3x.png 3x"
           class="not-found-check"
           alt="openpay logo"
      >
    </div>

    <span class="not-found-title">
      404 - Página no encontrada
    </span>

    <div class="not-found-content">
      Lo sentimos esta página no existe o no se encuentra disponible
      <p><span class="go-back-hyperlink" (click)="goToHome()">Regresa a Tiendanube</span></p>
    </div>

  </div>

</div>
